import type { SelectChangeEvent } from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";

import SettingRadio from "@app/analytics/account/components/SettingRadio";
import { getSettingDisabledOpts } from "@app/analytics/account/UserPreferences/utils";
import type { CalendarPermissionLevel } from "@app/analytics/types";
import type { UserSettings } from "@app/common/types";

import { Column } from "@rui/Stack";
import TooltipWrapper from "@rui/TooltipWrapper";

interface CalendarPermissionLevelOption {
  value: CalendarPermissionLevel;
  label: string;
  recommended: boolean;
}

const CALENDAR_PERMISSION_LEVELS: CalendarPermissionLevelOption[] = [
  {
    value: "all",
    label: "Join all calendar events",
    recommended: true,
  },
  {
    value: "hosting_only",
    label: "Join calendar events where I am the host",
    recommended: false,
  },
];

const MeetingRoleSelect = ({
  onChange,
  options,
  selected,
}: {
  onChange: (settings: Partial<UserSettings>) => void;
  options: CalendarPermissionLevel[];
  selected: CalendarPermissionLevel;
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    const calendarPermissionLevel = event.target
      .value as CalendarPermissionLevel;
    onChange({ calendarPermissionLevel });
  };

  return (
    <Column sx={{ color: "shades.neutral.800" }} spacing={1}>
      <Typography variant="bodyPrimaryMed">Meeting Role</Typography>
      <Column ml={0}>
        <RadioGroup onChange={handleChange}>
          {CALENDAR_PERMISSION_LEVELS.map(({ value, label, recommended }) => {
            const { disabled: optionIsDisabled, tooltip } =
              getSettingDisabledOpts(
                options.length > 1,
                options.includes(value)
              );

            return (
              <TooltipWrapper
                key={value}
                show={optionIsDisabled}
                title={tooltip}
              >
                <SettingRadio
                  value={value}
                  checked={value === selected}
                  disabled={optionIsDisabled}
                  label={label}
                  recommended={recommended}
                />
              </TooltipWrapper>
            );
          })}
        </RadioGroup>
      </Column>
    </Column>
  );
};

export default MeetingRoleSelect;
